import { oc } from '@orpc/contract'
import { z } from 'zod'

export const creditsResetModeSchema = z.enum(['monthly', 'manual'])

/**
 * Everything the sidebar bar and its tooltip need, for one project: the
 * organization's budget and what it has spent this window, the project's own
 * cap and spend, the caller's own share, and whether new work is blocked.
 */
export const creditsGetUsageContract = oc.input(z.object({ projectId: z.string().min(1) })).output(
  z.object({
    org: z.object({
      id: z.string(),
      name: z.string(),
      limit: z.number(),
      used: z.number(),
      resetMode: creditsResetModeSchema,
      /** End of the current window (monthly), null in manual mode. */
      periodEnd: z.string().nullable(),
    }),
    project: z.object({
      cap: z.number().nullable(),
      used: z.number(),
    }),
    me: z.object({ used: z.number() }),
    blocked: z.boolean(),
    reason: z.enum(['org', 'project']).optional(),
  })
)
